import {STUDENT_MARITAL_STATUS_MARRIED} from "../constants/MAGIC_NUMBERS";

export const tableC1a = (form) => {
    const medicareHIRateConstants = {
        'notMarried': {
            'incomeSplit': 200000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        },
        'marriedJoint': {
            'incomeSplit': 250000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        },
        'marriedSeparate': {
            'incomeSplit': 250000,
            'rateUpto': 0.0145,
            'rateOver': 0.0235
        }
    };

    let rateSource = (parseInt(form.step3.studentMaritalStatus) === STUDENT_MARITAL_STATUS_MARRIED)
        ? medicareHIRateConstants.marriedJoint
        : medicareHIRateConstants.notMarried;

    let income = parseInt(form.step3.studentAdjustedGrossIncome);
    let lower, higher = 0;

    if(income > rateSource.incomeSplit) {
        lower = rateSource.incomeSplit * rateSource.rateUpto;
        higher = (income - rateSource.incomeSplit) * rateSource.rateOver;
    } else {
        lower = income * rateSource.rateUpto;
    }

    return Math.round(lower + higher);
}

export const tableC1b = (form) => {
    const OASDIConstants = {
        'single': {
            'incomeMax': 147000,
            'percent': 0.062,
            'maximum': 9114
        },
        'married': {
            'incomeMax': 294000,
            'percent': 0.062,
            'maximum': 18228
        },
    };

    let dataSource = (parseInt(form.step3.studentMaritalStatus) === STUDENT_MARITAL_STATUS_MARRIED)
        ? OASDIConstants.married
        : OASDIConstants.single;

    let income =
        parseInt(form.step3.studentAdjustedGrossIncome) +
        parseInt(form.step3.studentOtherIncome);

    if(income > dataSource.incomeMax){
        return dataSource.maximum;
    }

    return Math.round(dataSource.percent * income);
}

export const tableC2 = (form) => {

    let size = parseInt(form.step3.familySize);

    if(size < 3) {
        return 0;
    }

    switch (size) {
        case 3: return 54580;
        case 4: return 67400;
        case 5: return 79530;
        case 6: return 93010;
    }

    let newFloor = 93010;
    let newAddition = 10510;

    return newFloor + (size - 6) * newAddition;
}
export const tableC3 = (form) => {
    let size = parseInt(form.step3.familySize);

    if(size < 2) {
        return 0;
    }

    switch (size) {
        case 2: return 51960;
        case 3: return 64700;
        case 4: return 79880;
        case 5: return 94260;
        case 6: return 110230;
    }

    let newFloor = 110230;
    let newAddition = 12460;

    return newFloor + (size - 6) * newAddition;
}

export const tableC4 = (value) => {
    return 0;
}

export const tableC5 = () => {
    return 0;
}

export const tableC6 = (adjustedIncome) => {
    const rawValue = (adjustedIncome) => {
        if (adjustedIncome < -6820) {
            return -1500;
        }

        if (adjustedIncome <= 20600) {
            return 0.22 * adjustedIncome;
        }

        if (adjustedIncome <= 25800) {
            return 4532 + (0.25 * (adjustedIncome - 20600));
        }

        if (adjustedIncome <= 31000) {
            return 5832 + (0.29 * (adjustedIncome - 25800));
        }

        if (adjustedIncome <= 36300) {
            return 7340 + (0.34 * (adjustedIncome - 31000));
        }

        if (adjustedIncome <= 41500) {
            return 9142 + (0.40 * (adjustedIncome - 36300));
        }

        return 11222 + (0.47 * (adjustedIncome - 41500));
    }

    return Math.round(rawValue(adjustedIncome));
}
